var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgGoogleplay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img_googleplay"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img_googleplay_2",
    filter: "url(#filter0_ii_122_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.54198 5.24964C4.54198 5.12026 4.55635 5.01108 4.57993 4.91995L11.7645 12.1332L4.57975 19.346C4.55627 19.2551 4.54198 19.1461 4.54198 19.0168V5.24964Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.732394
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.6614 12.7148L14.8132 14.3393L12.6167 12.1333L14.8131 9.92833L17.6616 11.553C17.6616 11.553 17.6616 11.5531 17.6616 11.5531C18.0277 11.762 18.1265 11.9859 18.1265 12.1336C18.1265 12.2814 18.0277 12.5055 17.6614 12.7148Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.732394
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_122_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8095 14.7625L12.1903 12.1331L4.46289 19.8912C4.74813 20.195 5.22 20.2324 5.75141 19.9298L14.8095 14.7625Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.09865 19.7718L12.1903 12.652L14.2121 14.6817L5.57023 19.6116C5.3823 19.7186 5.22605 19.7646 5.09865 19.7718Z",
    stroke: "white",
    strokeWidth: 0.732394
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.1908 11.6149L5.0984 4.49483C5.22582 4.50202 5.38207 4.54803 5.56995 4.65521L5.56997 4.65522L14.2122 9.58474L12.1908 11.6149Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.732394
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_122_1893",
    x: 4.17578,
    y: 4.12793,
    width: 14.3169,
    height: 16.0107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.582254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_122_1893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.582254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_122_1893",
    result: "effect2_innerShadow_122_1893"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_122_1893",
    x: 4.46289,
    y: 12.1331,
    width: 10.3467,
    height: 8.00562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.582254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_122_1893"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGoogleplay);
export default __webpack_public_path__ + "static/media/img_googleplay.72c5394ff267e9bdb104265ae629b6a9.svg";
export { ForwardRef as ReactComponent };